const CHART_COLORS  = {
  "Local communities": "#97001F",
  "Indigenous peoples": "#6054BA",
  "Non-governmental organisation (NGO)": "#00483A",
  "For-profit organisation (business and industry)": "#E7C802",
  "Sub-national government": "#4BC0C0",
  "Joint governance (i.e. decisions are made by many)": "#43B2ED",
  "Individual landowners": "#6380FF",
  "Collaborative governance (i.e. decisions are made by one group on behalf of many)": "#FF6384",
  "Non-profit organisation": "#00483A",
  "For-profit organisation": "#E7C802",
  "Joint governance": "#43B2ED",
}

export default CHART_COLORS